/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticuloModelDto } from '../../models/articulo-model-dto';

export interface InformacionAdicionalControllerObtencionArticulos$Params {

/**
 * Filtra los artículos por título (búsqueda parcial)
 */
  titulo?: string;

/**
 * Filtra los artículos por UUID de programa
 */
  uuidPrograma?: string;

/**
 * Filtra los artículos por fecha de creación desde
 */
  fechaCreacionDesde?: string;

/**
 * Filtra los artículos por fecha de creación hasta
 */
  fechaCreacionHasta?: string;

/**
 * Filtra los artículos por fecha de publicación desde
 */
  fechaPublicacionDesde?: string;

/**
 * Filtra los artículos por fecha de publicación hasta
 */
  fechaPublicacionHasta?: string;
}

export function informacionAdicionalControllerObtencionArticulos(http: HttpClient, rootUrl: string, params?: InformacionAdicionalControllerObtencionArticulos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ArticuloModelDto>>> {
  const rb = new RequestBuilder(rootUrl, informacionAdicionalControllerObtencionArticulos.PATH, 'get');
  if (params) {
    rb.query('titulo', params.titulo, {});
    rb.query('uuidPrograma', params.uuidPrograma, {});
    rb.query('fechaCreacionDesde', params.fechaCreacionDesde, {});
    rb.query('fechaCreacionHasta', params.fechaCreacionHasta, {});
    rb.query('fechaPublicacionDesde', params.fechaPublicacionDesde, {});
    rb.query('fechaPublicacionHasta', params.fechaPublicacionHasta, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ArticuloModelDto>>;
    })
  );
}

informacionAdicionalControllerObtencionArticulos.PATH = '/api/informacion-adicional/obtener-articulos';
